import { fork, takeEvery, put, putResolve } from "redux-saga/effects";
import { ChatAuthenticationActions, submitOtpKillSwitchAction, resendOtpKillSwitchAction, setSubmitOtpInfoKillSwitchAction, accessCodeLoginAction, setResendOtpInfoKillSwitchAction, resetOtpKillSwitchAction } from "../actions/chat-authentication-actions";
import { authenticationApi, getSessionId, accessCodeLoginApi, getAccessCodeLoginParamApi } from "../common/api";
import { ChatMsg, ConversationSessionResp } from "../types/chat-msg-types";
import { AccessCodePayload, AccessCodeReqBody, GetAccessCodeParam, OtpReq } from "../types/chat-authentication-types";
import { addChatMsgAction, showLadingIconAction, reSetChatMsgResultAction } from "../actions/chat-msg-actions";
import {BUDDY_MSG, CONFIG, DETECT_UN_ACTIVITY, FEEDBACK, FEEDBACK_SHOW, SESSION_ID} from "../common/config";

function* submitOtp(payload: any) {
    console.log("invoke submitOtp api");
    let resp = yield authenticationApi(payload.payload);
    console.log("rewp resp:", resp);
    if(resp && resp.status === "success") {
        //submitOtp succeed
        yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo:"",canClickSubmit: 3}));
        const buddyMsg: ChatMsg = {msg: resp.data, type: BUDDY_MSG, date: new Date()};
        yield put(addChatMsgAction(buddyMsg));
        yield put(showLadingIconAction(false));
    } else if (resp && resp.status === 401) {
        //reset chatMas
        yield putResolve(reSetChatMsgResultAction());
        //when detectIntent return 401,to get a new session again,and then detectIntent
        const resp: ConversationSessionResp = yield getSessionId();
        if (resp && resp.conversationSessionId) {
            // console.log("reset chat msg done====");
            sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
            sessionStorage.setItem(FEEDBACK,"true");
            sessionStorage.setItem(FEEDBACK_SHOW,"true");
            sessionStorage.setItem(DETECT_UN_ACTIVITY,"true");
            //resend 
            yield put(submitOtpKillSwitchAction(payload.payload));
        }
    } else {
        // let errorMsg = CONFIG.ERROR_MSG;
        //how to deal with sumit otp fail??? trigger sms opt intent again?or show some error in frot???
        console.log("sumitOtp error", resp);
        // const commonMsg: ChatMsg = {msg: errorMsg, type: BUDDY_COMMON, date: new Date()};
        if(resp && resp.error) {
            if(resp.authenticationData) {
                yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo:resp.error.message,canClickSubmit: resp.authenticationData.remainingCount?resp.authenticationData.remainingCount:0}));
            }else { 
                yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo:resp.error.message,canClickSubmit: 0}));
            }
        }
        //reset otp input
        yield put(resetOtpKillSwitchAction(true));
    }
}

function* resendOtp(payload: any) {
    console.log("invoke resend OTP");
    let resp = yield authenticationApi(payload.payload);
    console.log("rewp resp:", resp);
    if(resp && resp.status === "success") {
        //resendOtp succeed then can submit again
        if(resp.authenticationData) {
            yield put(setResendOtpInfoKillSwitchAction({killSwitchSendOtpInfo:"",canClickResend: resp.authenticationData.isRetryAllowed?resp.authenticationData.isRetryAllowed:false}));
        }
        yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo:"",canClickSubmit: 1}));
    } else if (resp && resp.status === 401) {
        //reset chatMas
        yield putResolve(reSetChatMsgResultAction());
        //when detectIntent return 401,to get a new session again,and then detectIntent
        const resp: ConversationSessionResp = yield getSessionId();
        if (resp && resp.conversationSessionId) {
            // console.log("reset chat msg done====");
            try {
                parent.postMessage(JSON.stringify({action:"chatbotSessionInitiated",sessionId:resp.conversationSessionId}), CONFIG.TARGET_ORIGIN)
            }catch (e) {
                console.log("parent.postMessage error",e)
            }

            sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
            //resend 
            yield put(resendOtpKillSwitchAction(payload.payload));
        }
    } else {
        // let errorMsg = CONFIG.ERROR_MSG;
        //how to deal with sumit otp fail??? trigger sms opt intent again?or show some error in frot???
        console.log("resendOtp error", resp);
        // const commonMsg: ChatMsg = {msg: errorMsg, type: BUDDY_COMMON, date: new Date()};
        if(resp && resp.error) {
            if(resp.authenticationData) {
                yield put(setResendOtpInfoKillSwitchAction({killSwitchSendOtpInfo:resp.error.message,canClickResend: (resp.authenticationData&&resp.authenticationData.isRetryAllowed)?resp.authenticationData.isRetryAllowed:false}));
            }else { 
                yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo:resp.error.message,canClickResend: false}));
            }
        }
        // const commonMsg: ChatMsg = {msg: errorMsg, type: BUDDY_COMMON, date: new Date()};
        // yield put(addChatMsgAction(commonMsg));
        // yield put(showLadingIconAction(false));
    }
}


function* mySaga() {
    yield takeEvery(ChatAuthenticationActions.KILL_SWITCH_OTP_SUBMIT, submitOtp);
    yield takeEvery(ChatAuthenticationActions.KILL_SWITCH_OTP_RESEND, resendOtp);
}

const chatAuthenticationSaga = [fork(mySaga)];

export default chatAuthenticationSaga;